import configService from '../../server/services/configService';

const config = configService.get();

export const NAME = 'header';
export const DEFAULT_STATE = {
  visible: true,
  persistedSearch: null,
  hasFocus: false,
  data: {},
  merchantCenterBetaTesters: config.merchantCenterBetaTesters,
  featureFlipping: {
    conversation: {
      isActive: config.featureFlipping.conversationIsActive,
    },
    merchantCenter: {
      isActive: config.featureFlipping.merchantCenterIsActive,
    },
    sellHomeRedirection: {
      isActive: config.featureFlipping.sellHomeRedirectionIsActive,
    },
    obfuscation: {
      isActive: config.featureFlipping.obfuscation,
    },
  },
};
